import { Component, ElementRef, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Coordinate } from 'src/app/Models/MisViajes/Coordinate';
import { Seguro } from 'src/app/Models/seguro';
import { AppInsightsService } from 'src/app/Services/appInsight.service';
import { Asegurado } from '../../Models/asegurado-detalle';
import { Day } from '../../Models/MisViajes/Day';
import { Month } from '../../Models/MisViajes/months';
import { Trip } from '../../Models/MisViajes/Trip';
import { TripsDay } from '../../Models/MisViajes/TripsDay';
import { ViajesMonthInfo } from '../../Models/MisViajes/viajesMonthInfo';
import { ApiService } from '../../Services/api.services';
import { formatNumber } from '@angular/common';

@Component({
  selector: 'app-viajes',
  templateUrl: './viajes.component.html',
  styleUrls: ['./viajes.component.css']
})
export class ViajesComponent implements OnInit{

  @Input()
  selectedKms: string;
  selectedMonth: Month;
  selectedTripsDay: Array<Trip>;
  selectedTrip: Trip;
  tripsDayData: TripsDay;
  asegurado: Asegurado;
  seguro: Seguro;
  loader: boolean;
  loaderMap: boolean;
  mapTrip: boolean;
  monthData: ViajesMonthInfo;
  listaMeses: Month[];
  defaultTextMonth: string;
  ultimaActualizacion: string;
  selectedDay: Day;
  selectedTripCoordinates: Coordinate[];
  @ViewChild('info', { static: false }) target: ElementRef;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private inj: Injector)
  {
    this.listaMeses = [];
    this.selectedKms = '0';
  }

  ngOnInit(): void {
    this.loader = true;
    this.loaderMap = false;
    this.mapTrip = false;
    this.asegurado = JSON.parse(localStorage.getItem('asegurado'));
    this.seguro = JSON.parse(localStorage.getItem('miSeguro'));

    let fechaHoy = new Date();
    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.logEvent(`Datos de MisViajes: (rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, Patente: ${this.seguro.poliza.patente}, Fecha Hora: ${fechaHoy.toString()})`);

    this.apiService.ObtainTravelsMonthData(this.asegurado.Rut, localStorage.getItem('firstIdVoucher')).subscribe((response: any) => {
      this.monthData = response;
      this.listaMeses = this.monthData.months;
      this.selectedMonth = this.monthData.months[0];
      let kmsFormatNumber: number = +this.monthData.months[0].kilometerstr;
      this.selectedKms = formatNumber(kmsFormatNumber ,'es-CL', '1.0');
      this.ultimaActualizacion = this.monthData.lastUpdate;
      this.loader = false;
    }, error => {
      this.handleOfferErrorTechniques(error);
    });

  }

  handleOfferErrorTechniques(error: any): void {
    this.router.navigate(['/errortechniques']);
  }

  onSelectMonth(selectedMonth: Month): void{

    let fechaHoy = new Date();
    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.logEvent(`Datos al Seleccionar el mes en MisViajes: (rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, Patente: ${this.seguro.poliza.patente}, Mes Seleccionado: ${selectedMonth.name}/${selectedMonth.year}  , Fecha Hora: ${fechaHoy.toString()})`);

    this.selectedMonth = selectedMonth;
    this.selectedKms = this.selectedMonth.kilometerstr;
    let kmsFormatNumber: number = +this.selectedMonth.kilometerstr;
    this.selectedKms = formatNumber(kmsFormatNumber ,'es-CL', '1.0');
  }

  onSelectDay(selectedDay: Day): void {
    this.seguro = JSON.parse(localStorage.getItem('miSeguro'));
    this.selectedDay = selectedDay;

    let fechaHoy = new Date();
    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.logEvent(`Datos al Seleccionar el día en MisViajes: (rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, Patente: ${this.seguro.poliza.patente}, Día Seleccionado: ${selectedDay.date} , Fecha Hora: ${fechaHoy.toString()})`);


    this.loaderMap = false;
    this.mapTrip = false;

    this.apiService.ObtainTravelsDayData(localStorage.getItem("firstIdVoucher"), selectedDay.number.toString(), this.selectedMonth.number+"" ,this.selectedMonth.year, this.seguro.facturacion.valorxKM).subscribe((response: any) => {
      this.tripsDayData = response;
      this.selectedTripsDay = this.tripsDayData.travels;
      this.selectedTrip = this.tripsDayData.travels[0];
      this.selectedTripCoordinates = null;
      // this.loaderMap = false;
      if (this.selectedTripsDay.length > 0){
        this.getCoordinatesByIdTrip(this.selectedTrip.idTrip);
      }

    }, error => {
      appInsightService.logException(error);
      this.handleOfferErrorTechniques(error);
    });
  }

  onSelectRoute(selectedRoute: Trip): void {
    this.selectedTrip = selectedRoute;
    this.loaderMap = true;
    this.mapTrip = false;
    this.getCoordinatesByIdTrip(this.selectedTrip.idTrip);
    let fechaHoy = new Date();
    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.logEvent(`Datos al Seleccionar una ruta en MisViajes: (rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, Patente: ${this.seguro.poliza.patente}, Día Seleccionado: ${this.selectedDay.date}, Inicio Ruta: ${selectedRoute.startTime}, Fin Ruta: ${selectedRoute.endTime}, Fecha Hora: ${fechaHoy.toString()})`);
  }

  getCoordinatesByIdTrip(idTrip: number): void{
    const appInsightService = this.inj.get(AppInsightsService);
    this.apiService.ObtainRouteCoordinatesList(idTrip).subscribe(response => {
      this.loaderMap = false;
      this.selectedTripCoordinates = response;
      if (this.selectedTripCoordinates.length > 0){
        this.mapTrip = true;
      }
    }, error => {
      appInsightService.logException(error);
      this.handleOfferErrorTechniques(error);
    });
  }
  scroll(): void {
    console.log(this.target);
    this.target.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
  }

}
